import { useEffect, useState } from 'react';

const readStoredValue = (key, fallback) => {
  if (typeof window === 'undefined') {
    return typeof fallback === 'function' ? fallback() : fallback;
  }

  try {
    const raw = window.localStorage.getItem(key);
    if (raw == null) {
      return typeof fallback === 'function' ? fallback() : fallback;
    }
    return JSON.parse(raw);
  } catch (err) {
    console.warn(`Failed to read persisted state for ${key}:`, err);
    return typeof fallback === 'function' ? fallback() : fallback;
  }
};

const usePersistentState = (key, fallback) => {
  const [value, setValue] = useState(() => readStoredValue(key, fallback));

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.warn(`Failed to persist state for ${key}:`, err);
    }
  }, [key, value]);

  return [value, setValue];
};

export default usePersistentState;
